<template>
    <div>
        <div class="nav">
            <img class="nav_back_img" src="../assets/title_nav.png" alt="">
            <div class="nav_float">
                <a href="#/"><span class="logo">RFID</span></a>
                <div class="nav_center_text">{{ $t("m.nav_center_text") }}</div>
                <div class="nav_menu_right">
                    <span class="menu_user"  v-if='p_data.loginState==1'>
                        <em>{{p_data.userName}}</em>
                        <ul class="user_float">
                            <li><a href="#/order">{{$t('m.Order_management')}}</a></li>
                            <li @click='storageLocal'>{{$t('m.quit')}}</li>
                        </ul>
                    </span>
                    <span class="menu_user menu_login" v-if='p_data.loginState==0'>
                        <em @click='isshowLogin=true'>{{$t('m.log_in')}}</em>
                        <em @click='isshowRegist=true'>{{$t('m.register')}}</em>
                    </span>
                    <a href="#/"><span class="menu_home">{{$t("m.return_home")}}</span></a>
                    <i class="language_toggle" @click="$toggle_lang">
                        <img src="../assets/lang_togg_icon.png" alt="">
                    </i>
                </div>
            </div>
        </div>

        <div class="step">
            <Steps :current="value1">
                <Step :title="$t('m.phone_info')"></Step>
                <Step :title="$t('m.phone_problem')"></Step>
                <Step :title="$t('m.your_location')"></Step>
                <Step :title="$t('m.Appointment')"></Step>
                <Step :title="$t('m.Pay')"></Step>
                <Step :title="$t('m.Payment_completed')"></Step>
            </Steps>
            <Carousel v-model="value1" arrow='never' dots='none'>
                <CarouselItem>
                    <div class="step_1">
                        <div class="step_nav">
                            <span>{{$t('m.index_title_1')}}</span>
                        </div>
                        <Row>
                            <Col span="8">
                                <Select v-model="brand1" size="large" style="width:80%;margin:0 auto;display:block;" clearable :not-found-text="$t('m.NoData')" :placeholder="$t('m.select_brand')" @on-change="change('brand')">
                                    <Option v-for="item in brand" :value="JSON.stringify(item)" :key="item.phoneBrandId">{{item.brandName}}</Option>
                                </Select>
                            </Col>
                            <Col span="8">
                                <Select v-model="model1" size="large" style="width:80%;margin:0 auto;display:block;" clearable :not-found-text="$t('m.select_model')" :placeholder="$t('m.select_model')" @on-change="change('model')">
                                    <Option v-for="item in model" :value="JSON.stringify(item)" :key="item.phoneModelId">{{ item.modelName }}</Option>
                                </Select>
                            </Col>
                            <Col span="8">
                                <Select v-model="color1"  size="large" style="width:80%;margin:0 auto;display:block;" clearable :not-found-text="$t('m.select_color')" :placeholder="$t('m.select_color')">
                                    <Option v-for="item in color" :value="JSON.stringify(item)" :key="item.colorValue">{{ item.colorName }}</Option>
                                </Select>
                            </Col>
                        </Row>
                        <div class="step_btn">
                            <Button :disabled='next_isDisabled' type="primary" size="large" @click='next(value1)'>{{$t("m.next")}}</Button>
                        </div>
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="step_1">
                        <div class="step_nav">
                            <i @click='value1--'></i>
                            <span>{{$t('m.What_is')}}</span>
                        </div>

                        <div class="check">
                            <b v-for='qu in czQues' :class='{sel:qu.isSel}' @click='selQue(qu)'>{{qu.title}}</b>
                        </div>

                        <div class="step_btn">
                            <Button :disabled='next_isDisabled' type="primary" size="large" @click='next(value1)'>{{$t("m.next")}}</Button>
                        </div>
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="step_1">
                        <div class="step_nav">
                            <i @click='value1--'></i>
                            <span>{{$t("m.We_want")}}</span>
                        </div>

                        <Row>
                            <Col span="24" style="text-align: center;">
                                <Input size="large" :placeholder="$t('m.select_address')" value="广东省深圳市龙华区民治" style="width:50%;">
                                    <Icon type="md-locate" slot="suffix" />
                                </Input>
                            </Col>
                        </Row>

                        <div class="step_btn">
                            <Button :disabled='next_isDisabled' type="primary" size="large" @click='next(value1)'>{{$t("m.next")}}</Button>
                        </div>
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="step_1">
                        <div class="step_nav">
                            <i @click='value1--'></i>
                            <span>{{$t('m.An_engineer')}}</span>
                        </div>

                        <Row>
                            <Col span="24" style="text-align: center;">
                                <DatePicker type="date" @on-change='selData' :options='opention' placement='bottom' :transfer='true' :editable='false' :placeholder="$t('m.select_date')" size="large" style="width: 30%;"></DatePicker>
                            </Col>
                        </Row>

                        <div class="check" style="margin-top: 30px;">
                            <b v-for='time in timeList' :class='{sel:time.isSel}' @click='selQue(time,timeList)'>{{time.sdate}}-{{time.edate}}</b>
                        </div>

                        <div class="step_btn">
                            <Button :disabled='next_isDisabled' type="primary" size="large" @click='next(value1)'>{{$t("m.next")}}</Button>
                        </div>
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="pay">
                        <span>{{$t('m.TheRepair')}}<strong>${{totalPrice}}</strong></span>
                        <b>{{$t('m.TheOrder')}}</b>
                        <b class="pay_tit">{{$t('m.phoneSituation')}}</b>
                        <b>{{JSON.parse(brand1).brandName}}{{JSON.parse(model1).modelName}} {{JSON.parse(color1).colorName}} / {{czQuesStr.join(',')}}</b>
                        <b  class="pay_tit">{{$t('m.RepairPoint')}}</b>
                        <b>广东省深圳市龙华区民治广东省深圳市龙华区民治</b>
                        <b>{{dataStr}} {{selTime.sdate}}-{{selTime.edate}} / 15319516715@163.com</b>
                        <b  class="pay_tit">{{$t('m.paymentMethod')}}</b>
                        <i @click="pay()"><img src="../assets/visa_icon.png" alt=""></i>
                    </div>
                    <div class="step_btn">
                        <Button :disabled='next_isDisabled' size="large" @click='value1=0'>{{$t("m.ReturnModif")}}</Button>
                    </div>
                </CarouselItem>
                <CarouselItem>
                    <div class="pay">
                        <span class="h1">{{$t('m.payment_successful')}}</span>
                        <b>{{$t('m.schedule_to_your_email')}}：{{mailbox}}</b>
                        <span>{{$t('m.Please_arrive')}} {{dataStr}} {{selTime.sdate}}</span>
                        <span class="h2">中国深圳龙华区民治梅花山庄C4栋</span>
                    </div>
                    <div class="step_btn">
                        <Button :disabled='next_isDisabled' type="primary" size="large" to='/order' style='color:#fff;'>{{$t('m.Order_management')}}</Button>
                    </div>
                </CarouselItem>
            </Carousel>
        </div>

        <Modal v-model="isshowSelLogin" :closable="false" :footer-hide="true" :mask-closable="false" class-name="sel_login_big">
            <div class="sel_login">
                <div class="title">{{$t('m.Please_login')}}</div>
                <span class="close" @click="(isshowSelLogin=false)||(operation_type='')"></span>

                <div class="login_icon">
                    <span class="icon">
                        <img src="../assets/facebook_icon.png" alt="">
                        <b>Facebook</b>
                    </span>
                    <span class="icon">
                        <i>
                            <img src="../assets/twitter_icon.png" alt="">
                        </i>
                        <b>Twitter</b>
                    </span>
                </div>
            </div>
            <div class="signUp" @click="(isshowSelLogin=false)||(isshowLogin=true)">{{$t('m.log_in')}}</div>
            <div class="signUp" @click="(isshowSelLogin=false)||(isshowRegist=true)">{{$t('m.register')}}</div>
        </Modal>
        <alan-regist :isshowRegist='isshowRegist' :close='()=>{isshowRegist = false}' :regi_succ='()=>{isshowRegist = false}'></alan-regist>
        <alan-login :isshowLogin='isshowLogin' :close='()=>{isshowLogin = false}' :login_succ='()=>{isshowLogin = false}'></alan-login>
    </div>
</template>

<script>
    import {Init,Req} from '../common/common.js'
    import md5 from 'md5'
    export default {
        name: "index",
        data () {
            return {
                brand:[],//品牌列表
                brand1:'{}',//已选品牌
                model: [],//型号列表
                model1: '{}',//已选型号
                color: [],//颜色列表
                color1: '{}',//已选颜色
                czQues:[],//手机问题列表
                czQuesStrId:[], //已选手机问题id列表
                czQuesStr:[], //已选手机问题列表
                opention:{
                    disabledDate (date) {
                        // console.log(date.toLocaleString());
                        const date1 = new Date();
                        // console.log(new Date(date1.getFullYear()+'-'+date1.getMonth()+'-'+date1.getDate()).toLocaleString());
                        // 不可选的时间      周末              或者               今天之前                      或者    十五天之后
                        return ((date.getDay()==0)||(date.getDay()==6))||(date.valueOf() < (Date.now() - 86400000))
                    }
                },
                timeList: [],//可选时间列表
                dataStr:'',//已选的日期
                selTime:{},//已选时间
                repairTime:'',//预计维修时间
                storeId:'',//店铺id
                totalPrice:'',//预计维修金额
                value1:0, //现在是第几步
                userId:'',//用户id
                isshowSelLogin: false,//是否显示选择登录方式弹窗
                isshowLogin: false,//是否显示选择登录方式弹窗
                isshowRegist:false,//是否显示注册弹窗
                email:'',//登录邮箱
                password:'',//登录密码
                reEmail:'',//注册输入的邮箱
                rePassword:'',//注册密码
                rePassword_t:'',//注册密码第二遍输入
                reUsername:'',//注册用户名
                userName:'',//页面显示的用户名
                operation_type:'',//强制登录之前的操作
                orderId:'',//订单id
                mailbox:localStorage.mailbox,//邮箱
                p_data:this.$store.state,//store的内容，全局
                next_isDisabled:false
            }
        },
        methods:{
            //选择问题勾选
            selQue(qu,list){
                if(list){
                 list.forEach(data=>{
                     data.isSel = false;
                 })   
                }
                qu.isSel = !qu.isSel
                
            },
            //选择手机型号的下拉框改变事件
            change(type){
                // console.log('选择了'+type);
                const vm = this;
                if(type == 'brand'){
                    vm.model1 = '{}';
                    vm.color1 = '{}';
                    vm.color = [];
                    if(vm.brand1){
                        vm.getModel(JSON.parse(vm.brand1).phoneBrandId);
                    }
                }else if(type == 'model'){
                    vm.color1 = '{}';
                    vm.color = [];
                    if(vm.model1){
                        vm.color = JSON.parse(JSON.parse(vm.model1).color);
                    }
                }else if(type == 'color'){
                    
                }
            },
            //获取品牌
            getBrand(){
                const vm = this;
                vm.$Loading.start();
                Req(Init('getPhoneBrandName'),res=>{
                    if(res.ret=='1'){
                        vm.brand = res.rows;
                        vm.$Loading.finish();
                    }else{
                        vm.$Loading.error();
                    }
                })
            },
            //获取型号
            getModel(_id){
                const resData = Init('getPhoneModelAndColor');
                resData.phoneBrandId  = _id;
                Req(resData,res=>{
                    if(res.ret=='1'){
                        this.model = res.rows;
                        // console.log(vm.brand);
                    }
                })
            },
            //下一步
            next(index){
                // console.log('现在是第'+(index+1)+'步');
                const vm = this;
                vm.next_isDisabled = true;
                if(index=='0'){
                    if(vm.brand1=='{}'){
                        vm.next_isDisabled = false;
                        vm.$Message.error(vm.$t('m.select_brand'));
                        return;
                    }
                    if(vm.model1=='{}'){
                        vm.next_isDisabled = false;
                        vm.$Message.error(vm.$t('m.select_model'));
                        return;
                    }
                    if(vm.color1=='{}'){
                        vm.next_isDisabled = false;
                        vm.$Message.error(vm.$t('m.select_color'));
                        return;
                    }
                    
                    //提交手机资料
                    vm.submitPhoneData(()=>{
                        //获取问题
                        vm.getQue(()=>{
                            vm.next_isDisabled = false;
                            vm.value1++
                        })
                    })
                }else if(index == '1'){
                    vm.czQuesStr = []
                    vm.czQuesStrId = []
                    vm.czQues.forEach(data=>{
                        if(data.isSel){
                            vm.czQuesStr.push(data.title)
                            vm.czQuesStrId.push(data.phoneQuestionId)
                        }
                    })
                    // console.log(vm.czQuesStr);
                    // console.log(vm.czQuesStrId);
                    if(vm.czQuesStrId.length){
                        vm.submitPhoneProblem(()=>{
                            vm.next_isDisabled = false;
                            vm.value1++
                        });
                    }else{
                        vm.next_isDisabled = false;
                        vm.$Message.error(vm.$t('m.What_is'));
                        return;
                    }
                }else if(index == '2'){
                    //定位好了坐标之后，拿着坐标跳到下一步
                    vm.value1++
                    vm.next_isDisabled = false;
                }else if(index == '3'){
                    //选了时间 提交刚刚已选择的东西
                    this.timeList.forEach(data=>{
                        if(data.isSel){vm.selTime = data;}
                    })
                    vm.userMailboxRegistration(()=>{
                        vm.value1++
                        vm.next_isDisabled = false;
                        // console.log(vm);
                    })
                    
                }
            },
            //提交手机资料
            submitPhoneData(callback){
                // console.log('提交手机资料');
                const vm = this;
                const resData = Init('submitPhoneData');
                resData.brandId = JSON.parse(vm.brand1).phoneBrandId;
                resData.brandName = JSON.parse(vm.brand1).brandName;
                resData.modelId  = JSON.parse(vm.model1).phoneModelId;
                resData.modelName  = JSON.parse(vm.model1).modelName;
                resData.color  = JSON.parse(vm.color1).colorValue;
                resData.colorName  = JSON.parse(vm.color1).colorName;
                resData.uuid   = vm.userId;  //未登录用户id
                resData.customerId   = localStorage.customerId;  //已登录用户id
                Req(resData,res=>{
                    if(res.ret=='1'){
                        callback&&callback();
                    }else{
                        vm.next_isDisabled = false;
                        vm.$Message.error(res.msg);
                    }
                })
            },
            //获取配件问题
            getQue(callback){
                // console.log('获取配件问题');
                const vm = this;
                const resData = Init('getPhoneProblem');
                resData.phoneModelId = vm.model1;
                Req(resData,res=>{
                    if(res.ret=='1'){
                        this.czQues = res.rows.map(data=>{
                          data.isSel = false;
                          return data;
                        });
                        callback&&callback();
                    }else{
                        vm.next_isDisabled = false;
                        vm.$Message.error(res.msg);
                    }
                })
            },
            //提交已选问题
            submitPhoneProblem(callback){
                const vm = this;
                const resData = Init('submitPhoneProblem');
                resData.phoneQuestionId  = vm.czQuesStrId.join(',');
                resData.phoneQuestion  = vm.czQuesStr.join(',');
                resData.uuid   = vm.userId;  //用户id
                resData.customerId   = localStorage.customerId;  //已登录用户id
                Req(resData,res=>{
                    if(res.ret=='1'){
                        callback&&callback();
                    }else{
                        vm.next_isDisabled = false;
                        vm.$Message.error(res.msg);
                    }
                })
            },
            //选择日期  提交坐标  114.046171,22.628446   并且获取可预约时间
            selData(dataStr){
                const vm = this;
                vm.dataStr = dataStr;
                const resData = Init('getStore');
                resData.phoneModelId = JSON.parse(vm.model1).phoneModelId;
                resData.phoneQuestionId = vm.czQuesStrId.join(',');
                resData.longitude = '114.046171';
                resData.latitude = '22.628446';
                resData.appointment = dataStr;
                resData.uuid   = vm.userId;  //用户id
                Req(resData,res=>{
                    if(res.ret=='1'){
                        vm.timeList = res.rows.map(data=>{
                            data.isSel = false;
                            return data;
                        });
                        vm.repairTime = res.params.repairTime;
                        vm.storeId = res.params.storeId;
                        vm.totalPrice = res.params.totalPrice;
                    }else{
                        vm.$Message.error(res.msg);
                    }
                })
            },
            //预约好时间下单接口
            userMailboxRegistration(callback){
                const vm = this;
                const resData = Init('submitAppointment');
                resData.brandName = JSON.parse(vm.brand1).brandName;
                resData.modelName  = JSON.parse(vm.model1).modelName;
                resData.color  = JSON.parse(vm.color1).colorValue;
                resData.uuid   = vm.userId;  //用户id
                resData.customerId   = localStorage.customerId;  //已登录用户id
                resData.phoneQuestionId = vm.czQuesStrId.join(',');
                resData.phoneQuestion  = vm.czQuesStr.join(',');
                resData.appointment = vm.dataStr; //预约时间 日期
                resData.sdate = vm.selTime.sdate; //预约时间 开始时间
                resData.edate = vm.selTime.edate; //预约时间 结束时间
                resData.storeId = vm.storeId; //店铺id
                resData.totalPrice  = vm.totalPrice ; //预计维修价格
                resData.repairTime  = vm.repairTime ; //预计维修时间
                resData.modelId  = JSON.parse(vm.model1).phoneModelId;
                resData.brandId = JSON.parse(vm.brand1).phoneBrandId;
                resData.colorName  = JSON.parse(vm.color1).colorName;
                Req(resData,res=>{
                    if(res.ret=='1'){
                        vm.orderId = res.params.orderId;
                        callback&&callback()
                    }else{
                        vm.next_isDisabled = false;
                        vm.$Message.error(res.msg);
                    }
                })
            },
            pay(){
                const vm = this;
                if(!localStorage.customerId){
                    vm.operation_type = '0'; // 0 支付  
                    vm.isshowLogin=true;
                    return;
                }
                // console.log('调用支付接口');
                
                const resData = Init('submitPayMoney');
                resData.orderId  = vm.orderId;
                resData.uuid   = vm.userId;  //用户id
                resData.customerId   = localStorage.customerId;  //已登录用户id
                Req(resData,res=>{
                    if(res.ret=='1'){
                        vm.$Message.success(vm.$t('m.payment_successful'));
                        vm.value1++
                    }else{
                        vm.$Message.error(res.msg);
                    }
                })
            }
        },
        created(){
            const vm = this;
            if(localStorage['userName']){vm.userName = localStorage['userName'];}
            if(sessionStorage['RFIDuuid']){vm.userId = sessionStorage['RFIDuuid']}
            vm.getBrand()
        }
    }
</script>
<style scoped>
    .nav{position:relative}
    .nav .nav_back_img{width:100%;}
    .nav .nav_float{position:absolute;width:100%;height:100%;left:0;top:0}
    .nav .logo{font-size:41px;font-weight:bold;color:#fff;position:absolute;left:48px;top:40px;cursor: pointer;}
    .nav_center_text{margin:0 auto;text-align:center;font-size:40px;color:#fff;position:relative;top:50%;letter-spacing:0.1rem}
    .nav_menu_right{position:absolute;right:34px;top:40px;font-size:15px;height:30px;line-height:30px;}
    .nav_menu_right span{color:#fff;display:inline-block;margin-right:1rem}
    .nav_menu_right .menu_user{background:url("../assets/jt_bottom.png") no-repeat right center;position:relative;cursor: pointer;padding-right:1rem;}
    .nav_menu_right .menu_user.menu_login{background:none;padding-right:0;}
    .nav_menu_right .menu_user.menu_login em{display:inline-block;margin-right:8px;}
    .nav_menu_right .menu_user:hover .user_float{display: block;}
    .nav_menu_right .menu_home{padding-left:1.6rem;padding-right:0;background:url("../assets/menu_home_icon.png") no-repeat left center;cursor: pointer;}
    .language_toggle{height:22px;width:22px;display:inline-block;position:relative;cursor: pointer;top:4px;}
    .language_toggle img{width:100%}

    .user_float{position:absolute;background:url("../assets/menu_back.png") no-repeat 0/100%;color:#000;padding:0 5px;width:130px;display: none;padding-top:5px;border:1px solid transparent;}
    .user_float li{height:50px;line-height:50px;text-align:center;border-bottom:1px dotted #a5a5a5;padding:0 9px;}
    .user_float li:hover{cursor: pointer;}
    .user_float li:last-child{border-bottom:none}

    .step{width:1000px; margin:0 auto;padding-top:50px;}
    .step .step_1{margin-bottom:175px;}
    .step .step_nav{padding:60px 0;}
    .step .step_nav i{display:inline-block;width:37px;height:37px;background:url("../assets/back_icon.gif") no-repeat center center/90%;position:absolute;}
    .step .step_nav span{display:block;text-align:center;font-size:25px;color:#000;}
    .step .check{text-align: center;}
    .step .check b{border:1px solid #bcbcbc;height:46px;padding:0 32px;display:inline-block;line-height:46px;font-size:15px;border-radius:3px;color:#5f5f5f;background:#efefef;margin:12px;font-weight: normal;}
    .step .check b:hover,.step .check b.sel{background:#fff;border-color:#b3beff;cursor: pointer;box-shadow: #ddd 6px 6px 25px;}
    .step .step_btn{text-align: center;padding-top:50px;}
    .step .ivu-select-selection{border:1px solid red;}
    .step .ivu-btn-large{padding:6px 30px 6px 30px}

    .pay{margin-top:50px;}
    .pay span{display:block;text-align:center;font-size:25px;color:#000;height:40px;}
    .pay span strong{color:#fe0e0e;font-weight: normal;}
    .pay b{font-size:18px;color:#a9a9a9;display:block;text-align:center;font-weight:normal;margin-bottom:15px;}
    .pay i{display:block;text-align:center;cursor: pointer;}
    .pay .h1{font-size:30px;}
    .pay .h2{font-size:18px;}
    .pay .pay_tit{color:#666;margin-top:30px;font-size:19px;}
    
    .sel_login{padding:40px;position: relative;}
    .sel_login .title{color:#5a5959;font-size:23px;}
    .sel_login .close{width:30px;height:30px;background: url("../assets/login_close.png") no-repeat 0/100%;display:inline-block;position:absolute;right:40px;top:42px;cursor: pointer;}
    .sel_login .login_icon{margin-top:20px;}
    .sel_login .login_icon .icon{display:inline-block;width:50%;text-align: center;margin-top:5px;cursor: pointer;}
    .sel_login .login_icon .icon img{padding:10px;}
    .sel_login .login_icon .icon b{display:block;font-size:18px;color:#8e8e8e;font-weight:normal;}

    .sel_login .from{margin:35px 0 5px;}
    .sel_login .from .sel_login_input{margin-bottom:25px;}
    .sel_login .bottom_button{text-align: right;}
    .sel_login .bottom_button button{width: 100%;height:45px;}
    .sel_login .bottom_button .sel_login_wjmm{font-size:14px;color:#666;text-align: right; display:inline-block;margin-top:8px;}

    .signUp{border-top:1px solid #e5e5e5;height:64px;line-height:64px;text-align: center;color:#4580ed;cursor: pointer;width:50%;display: inline-block;}
</style>